import React from 'react'

// SVGs
import Facebook from './svg/facebook'
import Sms from './svg/sms'
// import Twitter from './svg/twitter'
import Whatsapp from './svg/whatsapp'

// export default function share() {
const Share = ({ hideText, link, printId, title }) => {
  const openLink = ({ link, type, title }) => {
    let url = `${process.env.GATSBY_COMPANY_URL.replace(/\/$/, '')}${link}`
    let message = `Hey, Found this on ${process.env.GATSBY_COMPANY_NAME}, thought you might be interested.`

    switch (type) {
      case 'facebook':
        window.open(`https://www.facebook.com/sharer/sharer.php?u=${url}`)
        break
      case 'sms':
        window.open(`sms:?&body=${encodeURI(message)} ${url}`)
        break
      case 'whatsapp':
        window.open(`whatsapp://send?text=${message} ${url}`)
        break

      default:
    }
  }

  const printDiv = (divId) => {
    const printContents = document.getElementById(divId).innerHTML
    const originalContents = document.body.innerHTML
    document.body.innerHTML = printContents
    window.print()
    document.body.innerHTML = originalContents
  }

  const linkStyle = 'flex flex-row items-center gap-2 p-2 rounded bg-stone-50 hover:bg-white shadow border group'
  const iconStyle = 'group-hover:opacity-80'

  return (
    <div className='relative'>
      <div className='prose max-w-none'>
        {!hideText && <h2>Share</h2>}
        <div className='flex flex-wrap items-start gap-3'>
          {printId && (
            <button className={linkStyle} onClick={() => printDiv(printId)}>
              <svg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' strokeWidth={1.5} stroke='currentColor' className={`${iconStyle} w-8 h-8`}>
                <path
                  strokeLinecap='round'
                  strokeLinejoin='round'
                  d='M6.72 13.829c-.24.03-.48.062-.72.096m.72-.096a42.415 42.415 0 0 1 10.56 0m-10.56 0L6.34 18m10.94-4.171c.24.03.48.062.72.096m-.72-.096L17.66 18m0 0 .229 2.523a1.125 1.125 0 0 1-1.12 1.227H7.231c-.662 0-1.18-.568-1.12-1.227L6.34 18m11.318 0h1.091A2.25 2.25 0 0 0 21 15.75V9.456c0-1.081-.768-2.015-1.837-2.175a48.055 48.055 0 0 0-1.913-.247M6.34 18H5.25A2.25 2.25 0 0 1 3 15.75V9.456c0-1.081.768-2.015 1.837-2.175a48.041 48.041 0 0 1 1.913-.247m10.5 0a48.536 48.536 0 0 0-10.5 0m10.5 0V3.375c0-.621-.504-1.125-1.125-1.125h-8.25c-.621 0-1.125.504-1.125 1.125v3.659M18 10.5h.008v.008H18V10.5Zm-3 0h.008v.008H15V10.5Z'
                />
              </svg>
              <span className='sr-only'>Print</span>
            </button>
          )}
          <button
            className={linkStyle}
            onClick={openLink.bind(null, {
              type: 'facebook',
              link,
              title
            })}>
            <Facebook alt='Facebook' aria-hidden='true' className={`${iconStyle} w-8 h-8 text-[#3b5998]`} />
            <span className='sr-only'>Facebook</span>
          </button>
          <button
            className={linkStyle}
            onClick={openLink.bind(null, {
              type: 'whatsapp',
              link,
              title
            })}>
            <Whatsapp alt='Whatsapp' aria-hidden='true' className={`${iconStyle} w-8 h-8 text-[#25D366]`} />
            <span className='sr-only'>Share via Whatsapp</span>
          </button>
          <button
            className={linkStyle}
            onClick={openLink.bind(null, {
              type: 'sms',
              link,
              title
            })}>
            <Sms alt='SMS' aria-hidden='true' className={`${iconStyle} w-8 h-8 text-neutral-700`} />
            <span className='sr-only'>Send by SMS</span>
          </button>
          {/* <button
            className={linkStyle}
            onClick={openLink.bind(null, {
              type: 'twitter',
              link,
              title
            })}>
            <Twitter alt='twitter' aria-hidden='true' className={`${iconStyle} w-6 h-6 m-1 text-[#38a1f3]`} />
            <span className='sr-only'>Share on Twitter</span>
          </button> */}
        </div>
      </div>
    </div>
  )
}
export default Share
